<div class="modal-header" appCustomAutofocus>
    <h3>Location on {{data.Day}}</h3>
</div>
<div class="modal-body">
    <div class="card-body">
        <div *ngIf="mapPoints?.length > 0" class="row">
            <div class="col-lg-8">
                <div class="card" style="border-bottom: none; margin-bottom: 3px;">
                    <div class="card-header bg-light">
                        <div style="display:inline-block; padding:6px 12px; font-weight:bold;">Legend:</div>
                        <div style="display: inline-block; margin-right: 16px;">
                            <img style="height:32px; " src="https://www.google.com/intl/en_us/mapfiles/ms/micons/green-dot.png" alt="Green Dot" />
                            Clocked In
                        </div>
                        <div style="display: inline-block; margin-right: 16px;">
                            <img style="height:32px; " src="https://www.google.com/intl/en_us/mapfiles/ms/micons/red-dot.png" alt="Red Dot" />
                            Clocked Out
                        </div>
                        <div style="display: inline-block; margin-right: 16px;">
                            <img style="height:32px; " src="https://www.google.com/intl/en_us/mapfiles/ms/micons/yellow-dot.png" alt="Yellow Dot" />
                            Job Site
                        </div>
                        <button type="button" class="btn btn-outline-dark" (click)="mapAllPoints()">
                            Show All
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 d-none d-lg-block d-xl-block">
                <div class="alert alert-warning">Click a line below to see the location.</div>
            </div>
        </div>
        <div *ngIf="mapPoints?.length > 0" class="row">
            <div class="col-lg-8">
                <div #map2Div id="map2" style="height:300px;"></div>
            </div>
            <div class="col-md-12 d-block d-md-block d-lg-none">
                <div class="alert alert-warning" style="margin-top:12px;">Click a line below to see the location.</div>
            </div>
            <div class="col-lg-4" style="max-height: 300px; overflow-y: auto;">
                <table class="table">
                    <thead>
                        <tr>
                            <th style="font-weight:bold;">Action</th>
                            <th style="font-weight:bold;">Time</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let point of filteredPoints" (click)="mapSinglePoint(point)" class="clickableRow" style="cursor: pointer">
                            <td>
                                <span *ngIf="point.ClockAction">Clock In</span>
                                <span *ngIf="!point.ClockAction">Clock Out</span>
                            </td>
                            <td>
                                {{point.DisplayDate}} - {{point.DisplayTime}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div *ngIf="mapPoints?.length < 1">There is no GPS location recorded.</div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="closeClicked()">Close</button>
</div>